module.exports = __webpack_public_path__ + "img/ascdi-logotype.e65dfadd.png";